<script setup>
import { useResultsStore } from "../../stores/results";
import { useFilterStore } from "../../stores/filter";
import Icon from "../Common/Icon.vue";
import Loader from "../Common/Loader.vue";
import { useCollectionStore } from "../../stores/collection";
import { onMounted, ref } from "vue";

const emit = defineEmits(["open-filter", "toggle-order", "search"]);
const searchTerm = defineModel();

const filterStore = useFilterStore();
const resultsStore = useResultsStore();
const collectionStore = useCollectionStore();

const searchInput = ref(null);

function onSearch() {
  if (!resultsStore.isLoading && searchTerm.value !== "") {
    emit("search");
    searchInput.value.blur();
  }
}

onMounted(() => {
  searchInput.value.focus();
});
</script>

<template>
  <div class="container content-top-padding mb-16 lg:mb-20">
    <h1
      v-t="'search.headline'"
      class="font-bold text-31 sm:text-39 md:text-49 xxl:text-76 mb-10 md:mb-16 xxl:mb-20 lg:max-w-[90%]"
    ></h1>

    <form @submit.prevent="onSearch" class="relative mb-10 w-full xl:w-2/3 md:mb-12 lg:mb-14">
      <input
        ref="searchInput"
        type="text"
        required
        v-model="searchTerm"
        name="search"
        id="search"
        class="w-full border border-dark/10 bg-white outline-none text-16 lg:text-20 font-medium px-6 pr-20 lg:px-10 lg:pr-32 py-4 lg:py-6"
        :placeholder="$t('search.placeholder')"
      />
      <button
        type="submit"
        class="absolute right-0 top-0 bg-primary aspect-square h-full flex items-center justify-center"
      >
        <Icon v-if="!resultsStore.isLoading" name="search" class="shrink-0 size-5 text-white" />
        <Loader v-if="resultsStore.isLoading" class="shrink-0 size-5 text-white" />
      </button>
    </form>

    <div class="md:flex space-y-4 md:space-y-0 items-center flex-wrap gap-x-10 lg:gap-x-20">
      <button
        type="button"
        @click="emit('open-filter')"
        :class="filterStore.isAnyFilterActive ? 'text-primary' : ''"
        class="flex items-center gap-x-4 text-16 lg:text-20 text-dark hover:text-primary transition-colors"
      >
        <Icon name="filter" class="size-5 shrink-0" />
        <div>
          <span v-t="'button.filter'"></span>
          <span v-if="collectionStore.activeCollection" v-text="` (${collectionStore.activeCollection.name})`"></span>
        </div>
      </button>

      <button
        type="button"
        @click="emit('toggle-order')"
        :disabled="resultsStore.isLoading"
        class="flex items-center gap-x-4 text-16 lg:text-20 disabled:opacity-70 disabled:pointer-events-none hover:text-primary transition-colors"
      >
        <Icon :name="`order-${filterStore.order}`" class="size-5 shrink-0" />
        <span v-t="`button.order.date.${filterStore.order}`"></span>
      </button>
    </div>
  </div>
</template>
